import { z } from "zod";

export const WordListsPreferencesSchema = z.object({
  words_students_should_know: z.array(z.string()).default(["thesis"]),
  words_students_should_avoid: z.array(z.string()).default([]),
});

export const UserPreferencesSchema = z.object({
  word_lists: WordListsPreferencesSchema.default({
    words_students_should_know: ["thesis"],
    words_students_should_avoid: [],
  }),
  use_deep_analysis: z.boolean().default(false),
});

export type WordListsPreferences = z.infer<typeof WordListsPreferencesSchema>;
export type UserPreferences = z.infer<typeof UserPreferencesSchema>;
